var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],ref:`codemirror-${_vm.uuid}`,domProps:{"value":(_vm.code)},on:{"input":function($event){if($event.target.composing)return;_vm.code=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }